"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkloadsLoadableModel = void 0;
const core_1 = require("@veeam/core");
require("../../components");
class WorkloadsLoadableModel extends core_1.LoadableModel {
}
exports.WorkloadsLoadableModel = WorkloadsLoadableModel;
//# sourceMappingURL=WorkloadsLoadableModel.js.map